module.exports = __webpack_public_path__ + "static/media/Classic Alien.5a15a33e.jpg";